module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod);
    global.lib = mod.exports;
  }
})(this, function (module) {
  'use strict';

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  (function (name, definition) {
    if (typeof module != 'undefined') module.exports = definition();else if ("function" == 'function' && _typeof(__webpack_require__(2)) == 'object') !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else this[name] = definition();
  })('$', function () {
    // todos
    // add width() and height() and animate class to library


    /**
     * @name smallSelector
     * @public
     * @namespace app
     * @param  {query} element - DOM element query
     */
    function smallSelector(query) {
      this.target = query;
    }

    /**
     * @name addClass
     * @private
     * @param  {string} className - remove class element
     */
    function _removeClass(className) {
      if (!this.target || !className) {
        return;
      } else {
        for (var i = this.target.length - 1; i >= 0; i--) {
          this.target[i].className = this.target[i].className.replace(className, '');
        }
      }
    }

    /**
     * @name addClass
     * @private
     * @param  {string} className - add class element
     */
    function _addClass(className) {
      if (!this.target || !className) {
        return;
      } else {
        for (var i = this.target.length - 1; i >= 0; i--) {
          var classString = this.target[i].className,
              nameIndex = classString.indexOf(className);
          classString = classString.trim();
          if (nameIndex < 0) {
            classString += ' ' + className;
          }
          this.target[i].className = classString;
        }
      }
    }

    /**
     * @name toggleClass
     * @private
     * @param  {string} className - toggle class element
     */
    function _toggleClass(className) {
      for (var i = this.target.length - 1; i >= 0; i--) {
        var classString = this.target[i].className,
            nameIndex = classString.indexOf(className);
        classString = classString.trim();
        if (nameIndex < 0) {
          classString += ' ' + className;
        } else {
          classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
        }
        this.target[i].className = classString;
      }
    }

    /**
     * @name find
     * @private
     * @param  {string} className - DOM element query that will be find
     */
    function _find(query) {
      var _target = this.target;
      this.target = [];

      for (var i = _target.length - 1; i >= 0; i--) {
        var current = _target[i];
        current = current.querySelectorAll(query);
        for (var j = current.length - 1; j >= 0; j--) {
          this.target.push(current[j]);
        }
      }
    }

    /**
     * @name addListener
     * @private
     * @param  {string} type - DOM event that must be add to target
     * @param  {function} expression - event added function
     */
    function _addListener(type, expression) {
      var bubbling = false;
      for (var i = this.target.length - 1; i >= 0; i--) {
        if (window.addEventListener) {
          // Standard
          this.target[i].addEventListener(type, expression, bubbling);
        } else if (window.attachEvent) {
          // IE
          this.target[i].attachEvent('on' + type, expression);
        } else return false;
      }
    }

    /**
     * @name removeListene
     * @private
     * @param  {string} type - DOM event that must be add to target
     * @param  {function} expression - event remove function
     */
    function _removeListener(type, expression) {
      var bubbling = false;
      for (var i = this.target.length - 1; i >= 0; i--) {
        if (window.addEventListener) {
          // Standard
          this.target[i].removeEventListener(type, expression, bubbling);
        }
      }
    }

    /**
     * @name remove
     * @private
     * @action  remove selected element form DOM
     */
    function _remove() {
      for (var i = this.target.length - 1; i >= 0; i--) {
        this.target[i].remove();
      }
    }
    /**
     * @name hide
     * @private
     * @action  hide selected element
     */
    function _hide() {
      for (var i = this.target.length - 1; i >= 0; i--) {
        this.target[i].style.display = 'none';
      }
    }
    /**
     * @name show
     * @private
     * @action  show selected element
     */
    function _show(display) {
      var visible = display || 'block';
      for (var i = this.target.length - 1; i >= 0; i--) {
        this.target[i].style.display = visible;
      }
    }

    /**
     * @name html
     * @private
     * @action change html of selected DOM element
     */
    function _html(html) {
      for (var i = this.target.length - 1; i >= 0; i--) {
        this.target[i].innerHTML = html;
      }
    }
    /**
     * @name attr
     * @private
     * @action change Attribute of selected DOM element
     */
    function _attr(attr, value) {
      if (value) {
        for (var i = this.target.length - 1; i >= 0; i--) {
          this.target[i].setAttribute(attr, value);
        }
      } else {
        return this.target[0].getAttribute(attr);
      }
    }

    /**
     * @name css
     * @private
     * @action change style of selected DOM element
     */
    function _css(css) {
      var cssKeys = Object.keys(css);
      for (var i = this.target.length - 1; i >= 0; i--) {
        for (var j = cssKeys.length - 1; j >= 0; j--) {
          if (typeof css[cssKeys[j]] === 'number') {
            css[cssKeys[j]] = css[cssKeys[j]] + 'px';
          }
          this.target[i].style[cssKeys[j]] = css[cssKeys[j]];
        }
      }
    }
    /**
     * create instance of selcetor function
     */
    var $ = function $(query, $el) {
      var targetElementDOM = null;
      if (typeof query === 'string') {
        //if given parameter is a css query selector
        targetElementDOM = $el.querySelectorAll(query);
      } else if ((typeof query === 'undefined' ? 'undefined' : _typeof(query)) === 'object') {
        //if given parameter is a DOM object
        targetElementDOM = [];
        targetElementDOM.push(query);
      }
      if (targetElementDOM !== null) {
        return new smallSelector(targetElementDOM);
      }
    };

    $.fn = smallSelector.prototype = {
      version: '0.1.0',
      addClass: function addClass(className) {
        _addClass.call(this, className);
        return this;
      },
      removeClass: function removeClass(className) {
        _removeClass.call(this, className);
        return this;
      },
      toggleClass: function toggleClass(className) {
        _toggleClass.call(this, className);
        return this;
      },
      find: function find(query) {
        _find.call(this, query);
        return this;
      },
      on: function on(type, expression) {
        _addListener.call(this, type, expression);
        return this;
      },
      off: function off(type, expression) {
        _removeListener.call(this, type, expression);
        return this;
      },
      remove: function remove() {
        _remove.call(this);
        return this;
      },
      hide: function hide() {
        _hide.call(this);
        return this;
      },
      show: function show(display) {
        _show.call(this, display);
        return this;
      },
      css: function css(_css2) {
        _css.call(this, _css2);
        return this;
      },
      attr: function attr(_attr2, value) {
        _attr.call(this, _attr2, value);
        return this;
      },
      html: function html(_html2) {
        if (_html2) {
          _html.call(this, _html2);
        } else {
          if (this.target.length == 1) {
            return this.target[0].innerHTML;
          } else {
            var temp;
            for (var i = this.target.length - 1; i >= 0; i--) {
              temp = temp + this.target[i].innerHTML + "\n";
            }
            return temp;
          }
        }
      }
    };
    return $;
  });
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('./lib'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.lib);
    global.install = mod.exports;
  }
})(this, function (module, exports, $) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    install: function install(Vue, options) {
      //inject $v object into Vue Instances 
      Vue.prototype.$v = function (query) {
        // return query selector from virtual dom 
        return $(query, this.$el);
      };
    }
  };
  module.exports = exports['default'];
});

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// v-query.min.js